import { DataSourceType } from 'src/constants/dataSourceTypeDescription';
import { VirtualGraph } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isVirtualGraph } from 'src/containers/ProjectDiagram/utils/data';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateResourceDataSourceType =
  (resourceKey: string, newDataSourceType: DataSourceType) =>
  (model: Model) => {
    const resourceNodeData = model.nodeDataArray.find(
      (nodeData) => nodeData.key === resourceKey
    );
    if (resourceNodeData && isVirtualGraph(resourceNodeData)) {
      setDataProperty<VirtualGraph>(model)(
        resourceNodeData,
        'dataSourceType',
        newDataSourceType
      );
    }
  };
